import { useRef } from 'react';
import { T } from '../i18n';

export interface Dommage { type: string; zone: string; x: number; y: number; commentaire?: string; nouveau?: boolean }

/** Schema de carrosserie identique a celui du contrat papier — on pose les dommages dessus. */
export function SchemaVoiture({ dommages, anciens = [], onAjouter }:
  { dommages: Dommage[]; anciens?: Dommage[]; onAjouter?: (x: number, y: number) => void }) {
  const ref = useRef<HTMLDivElement>(null);

  function clic(e: React.MouseEvent) {
    if (!onAjouter || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    onAjouter((e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height);
  }

  return (
    <div className="edl-schema">
      <div ref={ref} style={{ position: 'relative' }} onClick={clic}>
        <svg viewBox="0 0 200 380" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" stroke="#8A93A2" strokeWidth="2" strokeLinejoin="round">
            <path d="M40 34 Q100 12 160 34 L172 96 Q176 190 172 284 L160 346 Q100 366 40 346 L28 284 Q24 190 28 96 Z" fill="#fff" />
            <path d="M52 66 Q100 52 148 66 L156 104 Q100 96 44 104 Z" fill="#F1F4F8" />
            <path d="M52 314 Q100 328 148 314 L156 278 Q100 286 44 278 Z" fill="#F1F4F8" />
            <rect x="46" y="120" width="108" height="140" rx="10" fill="#F6F8FA" />
            <path d="M28 118 L12 118 L12 150 L28 150" /><path d="M172 118 L188 118 L188 150 L172 150" />
            <line x1="46" y1="190" x2="154" y2="190" />
            <rect x="16" y="86" width="12" height="30" rx="3" fill="#EDEFF3" />
            <rect x="172" y="86" width="12" height="30" rx="3" fill="#EDEFF3" />
            <rect x="16" y="264" width="12" height="30" rx="3" fill="#EDEFF3" />
            <rect x="172" y="264" width="12" height="30" rx="3" fill="#EDEFF3" />
          </g>
          <text x="100" y="26" textAnchor="middle" fontSize="9" fill="#8A93A2">{T.schemaVoiture.avant}</text>
          <text x="100" y="360" textAnchor="middle" fontSize="9" fill="#8A93A2">{T.schemaVoiture.arriere}</text>
        </svg>
        {anciens.map((d, i) => (
          <div key={`a${i}`} className="point ancien" style={{ left: `${d.x * 100}%`, top: `${d.y * 100}%` }} title={T.schemaVoiture.constateDepart(d.commentaire ?? d.type)}>·</div>
        ))}
        {dommages.map((d, i) => (
          <div key={i} className={`point ${d.nouveau === false ? 'ancien' : ''}`} style={{ left: `${d.x * 100}%`, top: `${d.y * 100}%` }} title={d.commentaire ?? d.type}>{i + 1}</div>
        ))}
      </div>
      {onAjouter && <p className="mini sourdine" style={{ marginTop: 6, textAlign: 'center' }}>{T.schemaVoiture.toucherCarrosserie}</p>}
    </div>
  );
}

/** Signature au doigt ou a la souris. */
export function Signature({ valeur, onChange, label }: { valeur?: string; onChange: (v: string) => void; label: string }) {
  const ref = useRef<HTMLCanvasElement>(null);
  const dessine = useRef(false);

  const pos = (e: React.PointerEvent) => {
    const c = ref.current!, r = c.getBoundingClientRect();
    return { x: ((e.clientX - r.left) / r.width) * c.width, y: ((e.clientY - r.top) / r.height) * c.height };
  };
  const debut = (e: React.PointerEvent) => {
    dessine.current = true;
    const ctx = ref.current!.getContext('2d')!;
    const p = pos(e);
    ctx.strokeStyle = '#0F1B2D'; ctx.lineWidth = 2.2; ctx.lineCap = 'round';
    ctx.beginPath(); ctx.moveTo(p.x, p.y);
    ref.current!.setPointerCapture(e.pointerId);
  };
  const bouge = (e: React.PointerEvent) => {
    if (!dessine.current) return;
    const ctx = ref.current!.getContext('2d')!;
    const p = pos(e); ctx.lineTo(p.x, p.y); ctx.stroke();
  };
  const fin = () => { if (dessine.current) { dessine.current = false; onChange(ref.current!.toDataURL('image/png')); } };
  const effacer = () => {
    const c = ref.current!; c.getContext('2d')!.clearRect(0, 0, c.width, c.height); onChange('');
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5 }}>
        <span className="lbl">{label}</span>
        <button type="button" className="btn btn-s btn-f" onClick={effacer}>{T.schemaVoiture.effacer}</button>
      </div>
      <canvas ref={ref} width={520} height={140}
              style={{ width: '100%', height: 140, border: '1px solid var(--bord-fort)', borderRadius: 'var(--r-champ)', background: '#fff', touchAction: 'none' }}
              onPointerDown={debut} onPointerMove={bouge} onPointerUp={fin} onPointerLeave={fin} />
      {valeur && <div className="mini" style={{ color: 'var(--succes)', marginTop: 4 }}>{T.schemaVoiture.signe}</div>
}
    </div>
  );
}
